<template>
  <div class="bg-gray-100">
    <div class="mb-3 bg-white p-5 text-blue-500 text-center flex items-center justify-between">
      <div @click="back" class="left-3 top-6 text-m font-medium text-black hover:font-bold flex items-center">
        <i class="bi bi-chevron-left"></i>
        <span class="ml-2">{{ $t('back') }}</span>
      </div>
      <div class="text-xl font-bold">{{ $t('students_list') }}</div>
      <!-- This empty div is to balance out the space on the right side of the text -->
      <div></div>
    </div>
    <div v-if="loading" class="text-center py-4">Loading...</div>

    <div v-else v-for="(student, index) in students" :key="student.id" class="mb-2 mx-2 p-3 bg-white text-gray-600 rounded-lg shadow-sm">
      <div class="absolute text-blue-500 font-medium text-base">{{ index + 1 }}</div>
      <div class="relative text-base font-normal pl-5">{{ student.user.full_name }}</div>
    </div>
  </div>
</template>

<script>
import axiosClient from "@/axiosBot"; // assuming you have this set up already
import { useRoute } from 'vue-router';

export default {
  name: 'LessonSchedule',
  data() {
    return {
      students: [],
      lang: '',
      loading: false,
      room_id: ''
    };
  },
  computed: {

  },
  methods: {
    async fetchData() {
      this.loading = true;  // Set loading to true when starting to fetch
      try {
        const response = await axiosClient.get(`/schedule_students?room_id=${this.room_id}`);
        this.students = response.data;
      } catch (error) {
        console.error("Error fetching lessons:", error);
      } finally {
        this.loading = false;  // Set loading to false when done fetching
      }
    },
    back(){
      this.$router.push({ name: 'schedule_lessons', query: {
          date: this.$route.query.date, // Changed here
          teacher_id: this.$route.query.teacher_id  // Changed here
        } });
    }
  },
  created() {
    let tailwindJIT = document.createElement('script');
    tailwindJIT.setAttribute('src', 'https://cdn.tailwindcss.com');
    tailwindJIT.setAttribute('id', 'tailwind-jit-cdn');
    document.body.appendChild(tailwindJIT);
    let tailwindLink = document.createElement('link');
    tailwindLink.setAttribute('rel', 'stylesheet');
    tailwindLink.setAttribute('href', 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css');
    tailwindLink.setAttribute('id', 'tailwindcss-cdn');
    document.head.appendChild(tailwindLink);
  },
  mounted() {
    const route = useRoute();
    this.lang = route.query.lang;  // extracting lang from URL query
    this.room_id = route.query.room_id; // extracting teacher_id from URL query
    this.fetchData();
  }
}
</script>

<style scoped>
.schedule table {
  display: table;
  width: 100%;
}

.schedule tr {
  display: table-row;
}

.schedule td {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  padding: 5px;
}
</style>
